<div class="col-12 px-0">
    <app-header></app-header>
</div>

<div class="">
    <router-outlet></router-outlet>
</div>

<div class="col-12 px-0">
    <app-footer></app-footer>
</div>

<ngx-ui-loader fgsColor="#ffffff" overlayColor="rgb(0 0 0 / 60%)" hasProgressBar="false" pbThickness="0"
    textPosition="center-center" gap="0" logoPosition="center-center" logoSize="80"
    logoUrl="assets/images/icons/loader.gif" [fgsTemplate]="foregroundSpinner">
</ngx-ui-loader>
<ng-template #foregroundSpinner></ng-template>

<ng-template #timeOutModal let-modal>
    <div class="modal-body">
        <div class="col-12 px-0 d-flex flex-wrap py-3">
            <div class="col-12 text-center mb-2"><img alt="timeOutImg" src="assets/images/banners/logoutPopupImg.png"
                    width="90"></div>
            <div class="col-12 my-3 f-16 px-0 text-center">
                Your session will be terminated in <b> {{convertHoursForTable(countdownTimeSecond)}}</b>
                minutes due to inactivity.
            </div>
            <div class="col-12 d-flex justify-content-around p-0 pb-3">
                <button class="cardEnableBtn2 timeOutBtn"
                    (click)="modal.close();clickTrack('TimeOutOk','click')">Okay</button>
                <button class="cardEnableBtn timeOutBtn"
                    (click)="restartTimeOut();clickTrack('TimeOutWait','click')">Wait</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #tnCModel let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper">
            <div class="text-end">
                <img class="cursorPointer" (click)="tnCModalRef.close()" src="assets/images/icons/crossIcon.png"
                    alt="crossIcon" width="15" height="auto">
            </div>
            <div class="popupHeading">Terms & Conditions</div>
            <div class="tncSubHeading">"100 Reward Points" Program</div>
            <div class="d-flex align-items-baseline px-2">
                <ul class="popupTncTextUl">
                    <li *ngFor="let data of rewardPointsList" class="popupTncText">{{data}}</li>
                </ul>
            </div>
            <div class="tncSubHeading">"Flipkart Voucher of INR 100" Program</div>
            <div class="d-flex align-items-baseline px-2">
                <ul class="popupTncTextUl">
                    <li *ngFor="let data of flipkartVoucherList" class="popupTncText">{{data}}</li>
                </ul>
            </div>
            <div class="tncSubHeading">"TimesPrime Membership" Program</div>
            <div class="d-flex align-items-baseline px-2">
                <ul class="popupTncTextUl">
                    <li *ngFor="let data of timesPrimeList" class="popupTncText">{{data}}</li>
                </ul>
            </div>
            <div class="tncSubHeading">Set Transaction Preference</div>
            <div class="d-flex align-items-baseline px-2">
                <ul class="popupTncTextUl">
                    <li class="popupTncText" *ngFor="let data of transactionPrefrenceSet">{{data}}</li>
                </ul>
            </div>
            <div class="tncSubHeading">Set Card Level Transaction Limit</div>
            <div class="d-flex align-items-baseline px-2">
                <ul class="popupTncTextUl">
                    <li *ngFor="let data of cardTransactionLimit" class="popupTncText">{{data}}</li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #otpModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper">
            <div class="text-end"><img class="cursorPointer" (click)="closeModal()"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div class="popupHeading1">Enter OTP</div>
            <div class="popupSubHeading1">+91 {{commonServices.maskMobileNumber(commonServices.loginMobileNumber) ?
                commonServices.maskMobileNumber(commonServices.loginMobileNumber) : 'xx***xx**x' }}</div>
            <form #otpFormDetails="ngForm" (ngSubmit)="otpFormDetails.valid && otpNumber && submitOtp(otpFormDetails) ">
                <div class="popupSubHeading1">Enter <b>6 Digit OTP </b>sent on
                    {{commonServices.maskMobileNumber(commonServices.loginMobileNumber) ?
                    commonServices.maskMobileNumber(commonServices.loginMobileNumber) : 'xx***xx**x'}}</div>
                <div class="w-100 my-3">
                    <!-- <app-custom-otp-input #customOtpInput theme="underline"
                        [config]="{ length: 6,allowNumbersOnly:true,isPasswordInput: false,disableAutoFocus: true }"
                        (onInputChange)="otpChangeInput($event)"></app-custom-otp-input> -->
                    <ng-otp-input #modalOtp [config]="modalOtpInputConfig" name="modalOtp" required
                        (onInputChange)="otpChangeInput($event)" ngDefaultControl [(ngModel)]="otpNumber" ngModel>
                    </ng-otp-input>
                    <div class="validationBox mt-3" *ngIf="otpFormDetails.submitted && !otpNumber">Please enter the OTP.
                    </div>
                </div>
                <div>
                    <button class="cardEnableBtn w-100 py-3 px-5 mt-3"
                        [ngClass]="{'customDisabled': otpFormDetails.invalid || !otpNumber }">Submit & Save</button>
                </div>
                <div class="text-end popupResendOTP" (click)="resendOtp()">Resend OTP</div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #setupSucessful let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper">
            <div class="d-flex justify-content-center "><img src="assets/images/icons/successTickGif.gif"
                    alt="sucessIcon" width="40%" height="auto"></div>
            <div *ngIf="setUpSuccesFulChecks && setUpSuccesFulChecks == 'pinSetup' "
                class="popupSucessHeading text-center">PIN Updated Succesfully!</div>
            <div *ngIf="setUpSuccesFulChecks &&( setUpSuccesFulChecks == 'dashboardSetup') "
                class="popupSucessHeading text-center">Setup Saved Succesfully!</div>
        </div>
    </div>
</ng-template>

<ng-template #optOutModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper text-center">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeOptOut_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div class="d-flex justify-content-center"><img src="assets/images/icons/emojiSwingGif.gif" alt="sucessIcon"
                    width="70%" height="auto"></div>
            <div>
                <div class="popupHeading1">Hope to see you soon!</div>
                <div class="popupSub">Your response has been recorded and we will communicate with you in the future,
                    only as per your choice. </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #createPinModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper text-center pb-4">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeCreatePin_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <app-setuppin></app-setuppin>
        </div>
    </div>
</ng-template>

<ng-template #dataNotFoundModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center ">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeDataNotFound_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div>
                <img src="assets/images/banners/dataNotFoundBanner.gif" width="80%" height="auto" alt="bannerImg">
            </div>
            <div class="popupHeading1">Data Not Found</div>
            <div class="popupSub notDataFoundSubHeading">We are unable to fetch your records. kindly contact IndusInd
                Bank Credit Card customer support for further assistance. We regret the inconvenience caused.</div>
            <div class="cardEnableBtn w-100 py-3 px-5 mt-5" (click)="closeModal();clickTrack('TryAgain_DataNotFound_popup','click')">
                Try Again
            </div>
            <!-- <div class=" mt-3 text-end"><span class="popupResendOTP"  (click)="closeModal();"><a href="https://www.indusind.bank.in/in/en/personal/faq.html#Indus-Mobile-Credit-Card" target="_blank">Need Assistance?</a></span></div> -->
        </div>
    </div>
</ng-template>
<ng-template #failureModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center pb-5 ">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeFailure_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div>
                <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            </div>
            <div class="popupHeading1 my-3">Account Locked</div>
            <div class="popupSub">You have exhausted <b>all attempts</b> to fill the correct login details. Your login is blocked for 24 hours.</div>
            <!-- <div class=" mt-3 text-center"><span class="popupResendOTP" (click)="closeModal();"><a href="https://www.indusind.bank.in/in/en/personal/faq.html#Indus-Mobile-Credit-Card" target="_blank">Need Assistance?</a></span></div> -->
        </div>
    </div>
</ng-template>
<ng-template #incorrectOtpModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center pb-5 ">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeIncorrectOtp_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div>
                <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            </div>
            <div class="popupHeading1 my-3">Incorrect OTP</div>
            <div class="popupSub">You have exhausted all <b>{{config.remainingOtpAttempts}} attempts</b> to enter the
                correct OTP. Please try again after 24 hours.</div>
            <!-- <div class=" mt-3 text-center"><span class="popupResendOTP" (click)="closeModal();"><a href="https://www.indusind.bank.in/in/en/personal/faq.html#Indus-Mobile-Credit-Card" target="_blank">Need Assistance?</a></span></div> -->
        </div>
    </div>
</ng-template>
<!-- <ng-template #cardBlockModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center pb-5 ">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeIncorrectOtp_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div>
                <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            </div>
            <div class="popupHeading1 my-3">Blocked</div>
            <div class="popupSub"> Maximum response limit reached. Please login again after 24 Hours</div>
        </div>
    </div>
</ng-template> -->
<ng-template #languageModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center">
            <div class="text-end"><img class="cursorPointer"
                    (click)="closeModal();clickTrack('closeLanguage_popup','click')"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div *ngFor="let lang of languageoption" (click)="changeLanguage(lang)">{{lang.full}}</div>
        </div>
    </div>
</ng-template>
<ng-template #cardBlockRemoval let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center pb-5" *ngIf="cardBlockRemovalScreen == 1">
            <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            <div class="popupHeading1 greenTextBlock">Card block removal in progress....</div>
        </div>
        <div class="modalWrapperNoBg text-center pb-5 " *ngIf="cardBlockRemovalScreen == 2">
            <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            <div class="popupHeading1 greenTextBlock">Card unblocked successfully!</div>
        </div>
    </div>
</ng-template>

<ng-template #experienceRate let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper experienceRateWrapper">
            <div class="text-end"><img class="cursorPointer" (click)="closeModal();clickTrack('Close Popup Experience Rating','click')"
                src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div class="d-flex justify-content-center"><img src="assets/images/banners/experienceRatingBanner.png" class="experienceRateImg" alt="experienceRateBanner"></div>
            <div class="mx-2 mx-lg-4 text-center">Rate your Credit Card <span *ngIf="!commonServices.dashboardManageData['userInfo']['corporateCard']">activation</span> <br *ngIf="commonServices.dashboardManageData['userInfo']['corporateCard']"> experience with us!</div>
            <form #ratingForm="ngForm" (ngSubmit)="ratingForm.valid && postExperienceRating(ratingForm.value)">
                <div>
                    <div class="star-rating mt-3">
                        <input type="radio" required (change)="ratingInputCall($event,5)" id="5-stars" name="rating" value="5" />
                        <label for="5-stars" class="star">
                            <img src="assets/images/icons/starIcon.png" width="40" height="auto"  *ngIf="ratingValue <=4">
                            <img src="assets/images/icons/starIcon1.png" width="40" height="auto" *ngIf="ratingValue >= 5">
                        </label>
                        <input type="radio" (change)="ratingInputCall($event,4)" id="4-stars" name="rating" value="4" />
                        <label for="4-stars" class="star">
                            <img src="assets/images/icons/starIcon.png" width="40" height="auto"  *ngIf="ratingValue <= 3">
                            <img src="assets/images/icons/starIcon1.png" width="40" height="auto" *ngIf="ratingValue >= 4">
                        </label>
                        <input type="radio" (change)="ratingInputCall($event,3)" id="3-stars" name="rating" value="3" />
                        <label for="3-stars" class="star">
                            <img src="assets/images/icons/starIcon.png" width="40" height="auto"  *ngIf="ratingValue <= 2">
                            <img src="assets/images/icons/starIcon1.png" width="40" height="auto" *ngIf="ratingValue >= 3">
                        </label>
                        <input type="radio" (change)="ratingInputCall($event,2)" id="2-stars" name="rating" value="2" />
                        <label for="2-stars" class="star">
                            <img src="assets/images/icons/starIcon.png" width="40" height="auto"  *ngIf="ratingValue <= 1">
                            <img src="assets/images/icons/starIcon1.png" width="40" height="auto" *ngIf="ratingValue >= 2">
                        </label>
                        <input type="radio" (change)="ratingInputCall($event,1)" id="1-star" name="rating" value="1" />
                        <label for="1-star" class="star">
                            <img src="assets/images/icons/starIcon.png" width="40" height="auto"  *ngIf="!ratingValue">
                            <img src="assets/images/icons/starIcon1.png" width="40" height="auto" *ngIf="ratingValue >= 1">
                        </label>
                    </div>
                </div>
                <div class="text-left my-3">
                    Leave us a message
                </div>
                <div>
                    <textarea  name="ratingMessage" ngModel
                        #ratingMessage="ngModel" minlength="20" [required]="ratingValue < 4 && ratingValue > 0" placeholder="Type your review here.."  pattern="^[a-zA-Z\d-_., ]+$" ></textarea>
                    <div class="validationBox d-block text-danger text-left">
                        <div *ngIf="ratingMessage.invalid && ratingMessage.errors && ratingMessage.errors.required">
                            Message is required.
                        </div>
                        <div *ngIf="ratingMessage.invalid && ratingMessage.errors && ratingMessage.errors.pattern">
                            Special characters are not allowed.
                        </div>
                        <div *ngIf="ratingMessage.invalid && ratingMessage.errors && ratingMessage.errors.minlength">
                            Message should contain atleast 20 characters
                        </div>
                    </div>
                </div>
                <div>
                    <button  class="cardEnableBtn mt-2 w-100" type="submit" [ngClass]="{'customDisabled' : !ratingValue || ratingForm.form.status != 'VALID'  }">Submit</button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #feedbackSuccess let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper">
            <div class="d-flex justify-content-center "><img src="assets/images/icons/successTickGif.gif"
                    alt="sucessIcon" width="40%" height="auto"></div>
            <div class="popupSucessHeading text-center">Thank You for your feedback!</div>
        </div>
    </div>
</ng-template>

<ng-template #getAddOnCard let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapper addOncardWrapper text-center" [ngClass]="{'addOnCardPopperBlock' : showPopper}">
            <div class="text-end"><img class="cursorPointer" (click)="closeModal();clickTrack('close get add on card popup','click')" src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div class="d-flex justify-content-center "><img src="assets/images/banners/addOnCardGif.gif" alt="sucessIcon" width="60%" height="auto"></div>
            <div class="popupHeading mehroonTextBlock" style="font-size: 20px !important;">
                <!-- New Offer Unlocked!! -->
                Reward Points Unlocked!!
            </div>
            <div class="experienceRateWrapper mt-3" style="font-weight: 500;color: black;">
                <!-- Gift an Add-On Card to your loved ones at <b>Zero Cost!</b> -->
                Gift an Add-On Card to your loved ones at <b>Zero Cost </b> and 
                <div class="mt-2 rewardPointBlock"><b>Get 100 Reward Points</b></div>
            </div>
            <a [href]="commonServices['dashboardManageData']['addOnUrl']" target="_blank"><div class="gredientBtn mt-4 w-100" type="submit" (click)="clickTrack('get Add-on Card-popup', 'click')">Get Add-on Card</div></a>
        </div>
    </div>
</ng-template>

<ng-template #cardUnblocked let-modal>
    <div class="modal-body p-0">
        <div class="modalOblockWrapper text-center" [ngClass]="{'addOnCardPopperBlock' : showPopper}">
            <div class="text-end"><img class="cursorPointer" (click)="closeModal();clickTrack('close oblock unblocked popup- cross icon','click')" src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div class="d-flex justify-content-center my-4"><img src="assets/images/icons/successTickGif.gif" alt="sucessIcon" width="45%" height="auto"></div>
            <div class="popupOblockHeading mehroonTextBlock">
                Your card is already unblocked!
            </div>
            <div class="popupSubHeading1 mt-3">
                <b>Go ahead and activate your card.</b>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #attemptExhaustModal let-modal>
    <div class="modal-body p-0">
        <div class="modalWrapperNoBg text-center pb-5 ">
            <div class="text-end"><img class="cursorPointer"
                    (click)="clickTrack('close_oBlock_attemptExhaust_popup','click');closeModal()"
                    src="assets/images/icons/crossIcon.png" alt="crossIcon" width="15" height="auto"></div>
            <div>
                <img src="assets/images/banners/blueLockGif.gif" width="40%" height="auto" alt="bannerImg">
            </div>
            <!-- <div class="popupHeading1 my-3">Account Locked</div> -->
            <div class="popupSub">You have exhausted <b>all attempts</b> to fill the correct details. Try again after 24 hours.</div>
        </div>
    </div>
</ng-template>


